export default __webpack_public_path__ + "static/media/catalogos.363ba36d.mp4";